import { useState } from 'react';

const AdditionalLinks = (props) => {

    const [showMore, setShowMore] = useState(false);

    const handleShowMoreClick = (e) => {
        e.preventDefault();
        setShowMore(showMore => !showMore);
    };

    return (
        <div>
            <h2>{props.Title}</h2>
            <div className='additional-link-list cf'>
                {(props.AdditionalLinks && props.AdditionalLinks.length > 0) &&
                    <ul>
                        {props.AdditionalLinks.map(value =>
                            <li key={'show-' + value.Key}><h3><a href={value.Value}>{value.Key}</a></h3></li>)}
                    </ul>}
                {(props.HiddenAdditionalLinks && props.HiddenAdditionalLinks.length > 0) &&
                    <>
                        <div className={'additional-links-hide ' + (showMore ? '' : 'hidden')}>
                            <ul>
                                {props.HiddenAdditionalLinks.map(value =>
                                    <li key={'hidden-' + value.Key}><h3><a href={value.Value}>{value.Key}</a></h3></li>)}
                            </ul>
                        </div>
                        <div className='additional-links-show'>
                            <a href='#/' onClick={handleShowMoreClick}>
                            <span className='show-text'><strong>{showMore ? props.ShowLessText : props.ShowMoreText} </strong></span>
                            <span className='show-icon'><i className={'fas fa-arrow-circle-' + (showMore ? 'up' : 'down')} aria-hidden='true'></i></span>
                            </a>
                        </div>
                    </>}
            </div>
        </div>
    );
};

export default AdditionalLinks;